// extracted by mini-css-extract-plugin
module.exports = {"menuItemList":"MenuItemList_menuItemList__15B9v","menuItem":"MenuItemList_menuItem__oycFu"};